<template>
  <div class="row form-container justify-content-center" v-if="render">
    <!-- LOADER - AGUARDANDO A REQUISIÇÃO NO HUB -->
    <div class="col-12 col-md-10 col-lg-10 col-xl-10" v-if="renderLoad">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8 col-xl-8">

          <div class="tit text-center">
            <div class="svg" >
                <div class="relogio"></div>
            </div>
            <h1>Estamos carregando as informações, por favor aguarde um instante...</h1>
          </div>

          <div class="text-center">
            <a href="/" class="link" title="IOUU">
              <i class="ico-iouu" />
            </a>
            <p class="obs">Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- INFORMAÇÕES VÁLIDAS DO SERASA E SOLICITAÇÃO APROVADA -->
    <div class="col-12 col-md-10 col-lg-10 col-xl-10" v-if="renderSuccess">
      <div class="row justify-content-center" style="" v-if="hasAccount">
        <div class="col-12 col-md-10 col-lg-8 col-xl-8">

          <div class="tit text-center">
            <img src="/static/assets/images/ico-smile.svg" alt="Icone feliz">
            <h1>O 1º passo para você fazer parte da IOUU foi concluído com sucesso! </h1>
            <p>Identificamos que você já possui um cadastro conosco, faça <b>login</b> para poder finalizar o cadastro  e aguardar o processo de análise e aprovação.</p>
          </div>

          <div class="text-center suitability-link-container" v-if="hasAccount">
            <router-link :to="`/login?loansId=${loansId}`" class="btn btn-sm btn-primary" title="Fazer login">Entendi, quero fazer login</router-link>
          </div>

          <div class="text-center">
            <a href="/" class="link" title="IOUU">
              <i class="ico-iouu" />
            </a>
            <p class="obs">Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center" style="" v-else>
        <div class="col-12 col-md-10 col-lg-8 col-xl-8">

          <div class="tit text-center">
            <img src="/static/assets/images/ico-smile.svg" alt="Icone feliz">
            <h1>O 1º passo para você fazer parte da IOUU foi concluído com sucesso! </h1>
            <p>O próximo passo é criar um usuário, completar o <b>cadastro</b>, enviar os documentos e aguardar o processo de análise e aprovação.</p>
          </div>

          <div class="text-center suitability-link-container">
            <router-link :to="`/criar-conta-lead?name=${name}&email=${email}&loansId=${loansId}`" class="btn btn-sm btn-primary" title="Completar cadastro">Entendi, quero completar meu cadastro</router-link>
          </div>

          <div class="text-center">
            <a href="/" class="link" title="IOUU">
              <i class="ico-iouu" />
            </a>
            <p class="obs">Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- INFORMAÇÕES DO SERASA INVALIDAS OU INCOMPLETAS -->
    <div class="col-12 col-md-10 col-lg-10 col-xl-10" v-if="renderDanger">
      <div class="row justify-content-center" style="">
        <div class="col-12 col-md-10 col-lg-8 col-xl-8">
          <div class="tit text-center">
            <img src="/static/assets/images/emoticon-triste.svg" alt="Icone feliz">
            <h1>Infelizmente ocorreu um erro ao carregar as informações </h1>
            <p>Tente novamente mais tarde, sentimos muito pelo inconveniente!!!</p>
          </div>
          <div class="text-center">
            <a href="/" class="link" title="IOUU">
              <i class="ico-iouu" />
            </a>
            <p class="obs">Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- SOLICITAÇÃO REPROVADA  -->
    <div class="col-12 col-md-10 col-lg-10 col-xl-10" v-if="renderDenied">
      <div class="row justify-content-center" style="">
        <div class="col-12 col-md-10 col-lg-8 col-xl-8">
          <div class="tit text-center">
            <img src="/static/assets/images/ico-negado.svg" width="100" alt="Icone crédito negado.">
            <h1>Sua solicitação de crédito não foi aprovada.</h1>
            <p>Você já possui uma solicitação conosco, há um periodo de 3 meses para poder realizar uma nova solicitação!</p>
          </div>
          <div class="text-center">
            <a href="/" class="link" title="IOUU">
              <i class="ico-iouu" />
            </a>
            <p class="obs">Juntos vamos reinventar os serviços financeiros tradicionais e garantir um melhor negócio para todos.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/variables";
  @import "../assets/styles/iouu/mixins";

  div > {
    i {
      margin-top: 50px;
      font-size: 100px;
      line-height: 60px;
      color: $c3;
    }
  }
  .tit {
    img {
      width: 80px;
      margin-bottom: 40px
    }
  }

  .suitability-link-container {
    margin: 5vh 0;
  }

  @include xs {
    .steps {
      .btn-primary {
        width: 100%;
        padding: 14px 0;
        font-size: calcRem(13);
      }
    }
  }
</style>


<script>
import HubConsultaClient from "../utils/hub-consulta-client.js"
/*eslint-disable*/
  export default {
    data() {
      return {
        transitionName: 'slide-left',
        investor: null,
        render: true,
        renderLoad: true,
        renderSuccess: false,
        renderDanger: false,
        renderDenied: false,
        name: '',
        email: '',
        loansId: '',
        url: '',
        hasAccount: false,
      }
    },
    methods: {
        callLead() {
	    // Teste query serasa
	    //?event=PROPOSAL_ACCEPTED&authenticationCode=5a380375e0fce-1513620400554-tgdmt5xz3zh-B0569A7929900C999063641BC8E9176C

	           if(this.$route.query.authenticationCode !== "" &&
               this.$route.query.authenticationCode !== undefined &&
               this.$route.query.authenticationCode !== null) {
  	              HubConsultaClient.LeadSerasa(this.$route.query.authenticationCode)
                  .then((response) => {
                     if(response !== undefined && response !== null && response.data !== "" && response.data.Msg !== "possui solicitacao") {
                		     console.log(response.data)
                		     this.email = response.data.Email
                		     this.name = response.data.Nome
                		     this.loansId = response.data.SolicitacaoID
                         this.hasUser(this.email)
                         this.Success()
                      } else if(response !== undefined && response.data.Msg === "possui solicitacao") {
                          this.Denied()
              		    } else {
              			     this.Danger()
              		    }
                  })
                  .catch((error) => {
                      console.log(error)
                      this.Danger()
                  })
            } else {
                this.Danger()
            }
        },
        hasUser(email) {
              HubConsultaClient.ExisteUsuario(this.email)
              .then((resp) => {
                  if(resp.Msg === "Existe") {
                    this.hasAccount = true
                  }
              })
        },
        Success() {
            this.render = true;
            this.renderLoad = false;
            this.renderSuccess = true;
        },
        Danger() {
            this.render = true;
            this.renderLoad = false;
            this.renderDanger = true;
        },
        Denied() {
          this.render = true;
          this.renderLoad = false;
          this.renderDenied = true;
        },

      //tagueamento GA
      taggingGA() {
        this.$ga.page({
          page: '/call/serasa/ ',
          title: 'Lead Confirm',
        })
      },  
    },
    async created() {
      this.callLead();

      //tagueamento GA
      await this.taggingGA();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/ConfirmCadastroLead.vue